require("component-responsive-frame/child");
var $ = require('jquery');
const d3 = require("d3");

const monthTicks = require("./monthTicks.js");

const myFunction1 = require("./new_graph.js");
const buildHospitalGraph = require("./hospitals_graph.js");
const myFunction2 = require("./trends_graph.js");

//// change me every month ////
// var monthTicks = ["3/1/2020", "4/1/2020", "5/1/2020", "6/1/2020", "7/1/2020","8/1/2020","9/1/2020","10/1/2020","11/1/2020","12/1/2020","1/1/2021", "2/1/2021", "3/1/2021", "4/1/2021", "5/1/2021", "6/1/2021", "7/1/2021", "8/1/2021", "9/1/2021", "10/1/2021", "11/1/2021", "12/1/2021", "1/1/2022", "2/1/2022", "3/1/2022", "4/1/2022","5/1/2022"];
var hos_monthTicks = ["1/1/2021", "2/1/2021", "3/1/2021", "4/1/2021", "5/1/2021", "6/1/2021", "7/1/2021", "8/1/2021", "9/1/2021", "10/1/2021", "11/1/2021", "12/1/2021", "1/1/2022", "2/1/2022", "3/1/2022", "4/1/2022", "5/1/2022", "6/1/2022"];


var commafy = s => (s * 1).toLocaleString().replace(/\.0+$/, "");
var commaFormat = d3.format(',');

var county_pops = require("../assets/waPop2020.json");

var county_counts = window.CountyCounts;
var county_deaths = window.CountyDeaths;
var dohNumbers = window.DOH_Totals;
var hospitalData = window.Hospitals;

var stateTotal = 7656200;

let colors = {
  cases: ["#D8894E"],
  deaths: ["#D15959"],
  casesPop: ["#FFE9CF",'#ffc88a','#d28449','#914c14','#730505'],
  deathsPop: ['#ffd9d7','#ff9894','#d05858','#931f2b','#61000a'],
  cases_2Wks: ["#f77f50"],
  casesPop_2Wks: ['#ffe8d6', '#ffae83', '#f77f50', '#da492b', '#b30000']
}

let buckets = {
  cases: [1],
  deaths: [0.1],
  casesPop: [0.1, 1500.1, 1800.1, 2100.1, 2400.1],
  deathsPop: [0.1, 10.1, 20.1, 30.1, 40.1],
  cases_2Wks: [1],
  casesPop_2Wks: [0.1, 50.1, 100.1, 150.1, 200.1]
}

var months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
var ap_months = ["Jan.","Feb.","March","April","May","June","July","Aug.","Sept.","Oct.","Nov.","Dec."];

var day_var = county_counts[county_counts.length - 1];
day_var = day_var.Date;
day_var = day_var.split("/");
var dataMonth = day_var[0];
var dataDay = day_var[1];
dataMonth = parseInt(dataMonth) - 1;
var dateNew = months[dataMonth] + " " + dataDay + ", " + day_var[2];


// find all pages and see which one is showing
const new_cases = document.querySelector("#countyTrendGraphic");

if (new_cases) {
  myFunction1(dohNumbers, "casesCounty3", "CasesNew", monthTicks, ap_months, dateNew);

  $( ".radioButton3" ).click(function() {
    var cOrD = this.getAttribute('data-type');
    var thisID = $(this).attr("id");
    $('.title').toggleClass("showMe");

    myFunction1(dohNumbers, thisID, `${cOrD}New`, monthTicks, ap_months, dateNew);
  });
}


const hospitals = document.querySelector("#hospitalsGraphic");

if (hospitals) {
  buildHospitalGraph(hospitalData, dateNew, hos_monthTicks, ap_months);
}

const trends = document.querySelector("#countyTrendGraphic");

if (trends) {
  $( ".radioButton2" ).click(function() {
    var thisID = $(this).attr("id");
    $('.title').toggleClass("showMe");
    if ( thisID === "casesCounty2" ) {
      myFunction2(dohNumbers, thisID);
    } else {
      myFunction2(county_deaths, thisID);
    };
  });

  myFunction2(dohNumbers, "casesCounty2");
}

// const countyMap = document.querySelector("#countyMapGraphic");



if($('#countyMapGraphic').length >0 ){
  var countyMapGraphic = document.getElementById("countyMapGraphic");
  var lastest_day = county_counts.length - 1;
      lastest_day = county_counts[lastest_day];


  var lastest_deaths = county_deaths.length - 1;
      lastest_deaths = county_deaths[lastest_deaths];

  var svgCounty = d3.select("#svg3071"),
        gCounty = svgCounty.append("g");

  // console.log(lastest_deaths);
  unnCases = parseInt( lastest_day["Unassigned"] );
  unnDeaths = parseInt( lastest_deaths["Unassigned"] );

  $('.unassigned.cases.casesPop span').empty().append(commaFormat(unnCases));
  $('.unassigned.deaths.deathsPop span').empty().append(unnDeaths);

  $('#date').empty().text(dateNew);



  var countyMap = document.getElementById("svg3071");
  var counties = countyMap.getElementsByClassName("county");
  let caseTotals = 0;
  let deathTotals = 0;

  for (let i = 0; i < counties.length; i++) {
      var countyName = counties[i].id;
      var case_value = parseInt( lastest_day[countyName] );
      var death_value = parseInt( lastest_deaths[countyName] );
      caseTotals = caseTotals + parseInt(case_value);
      deathTotals = deathTotals + parseInt(death_value);
      var bbox = d3.select("#" + countyName).node().getBBox();

      var countyObj = county_pops[i];
      var countyPop = countyObj["pop_2020"];

      var popAdjCase = (case_value / countyPop) * 10000;
      popAdjCase = popAdjCase.toFixed(1);
      var popAdjDeath = (death_value / countyPop) * 10000;
      popAdjDeath = popAdjDeath.toFixed(1);

      let dataset = {
        cases: case_value,
        casesPop: popAdjCase,
        deaths: death_value,
        deathsPop: popAdjDeath
      };

      counties[i].numbers = dataset;

           var centroid = [
               bbox.x + bbox.width/2,
               bbox.y + bbox.height/2
           ];

       var pushVar = 0;

       if (countyName === "Walla_Walla") { pushVar =  30; };
       if (countyName === "Garfield") { pushVar =  -20; };
       if (countyName === "Columbia") { pushVar =  10; };
       if (countyName === "Franklin") { pushVar =  -20; };
       if (countyName === "Cowlitz") { pushVar =  -10; };

       countyName = countyName.replace(/_/g, ' ');



       		var circle = svgCounty.selectAll('g').append('text')
           .attr("class", "covidNum cases")
       		 .attr("font-weight","bold")
       		 .attr("text-anchor", "middle")
       		 .html(function () {
         	 	return ("<tspan class='headerC' x='" + centroid[0] + "' y='" + (centroid[1] + pushVar) + "'>" + countyName + "</tspan>" + "<tspan class='valueC' x='" + centroid[0] + "' y='" + (centroid[1] + pushVar + 20) + "'>" + commaFormat(case_value) + "</tspan>");
       		 });


       		 var circleDeaths = svgCounty.selectAll('g').append('text')
       			.attr("class", "covidNum deaths")
       			.attr("font-weight","bold")
       			.attr("text-anchor", "middle")
       			.html(function () {
       			 return ("<tspan class='headerC' x='" + centroid[0] + "' y='" + (centroid[1] + pushVar)  + "'>" + countyName + "</tspan>" + "<tspan class='valueC' x='" + centroid[0] + "' y='" + (centroid[1] + pushVar + 20) + "'>" + commaFormat(death_value) + "</tspan>");
       			});

            var circleAdjCases = svgCounty.selectAll('g').append('text')
             .attr("class", "covidNum casesPop")
             .attr("font-weight","bold")
             .attr("text-anchor", "middle")
             .html(function () {
               let white_text =  parseFloat(popAdjCase) > buckets.casesPop[3] ? "white" : "black";
              return (`<tspan class='headerC ${white_text}' x='` + centroid[0] + "' y='" + (centroid[1] + pushVar)  + "'>" + countyName + "</tspan>" + `<tspan class='valueC ${white_text}' x='` + centroid[0] + "' y='" + (centroid[1] + pushVar + 20) + "'>" + commaFormat(popAdjCase) + "</tspan>");
             });

             var circleAdjDeaths = svgCounty.selectAll('g').append('text')
              .attr("class", "covidNum deathsPop")
              .attr("font-weight","bold")
              .attr("text-anchor", "middle")
              .html(function () {
               // return ( popAdjDeath > 0.0 ? "<tspan class='headerC' x='" + centroid[0] + "' y='" + (centroid[1] + pushVar)  + "'>" + countyName + "</tspan>" + "<tspan class='valueC' x='" + centroid[0] + "' y='" + (centroid[1] + pushVar + 25) + "'>" + popAdjDeath + "</tspan>" : "");
               return ("<tspan class='headerC' x='" + centroid[0] + "' y='" + (centroid[1] + pushVar)  + "'>" + countyName + "</tspan>" + "<tspan class='valueC' x='" + centroid[0] + "' y='" + (centroid[1] + pushVar + 20) + "'>" + (popAdjDeath > 0.0 ? popAdjDeath : "0") + "</tspan>");
              });

  } // for loop end




  $('#casesTotal').empty().append(commaFormat(caseTotals + unnCases));
  $('#deathsTotal').empty().append(commaFormat(deathTotals + unnDeaths));

  var num = (caseTotals + unnCases) / stateTotal * 10000;
  num = num.toFixed(1);
  var num2 = (deathTotals + unnDeaths) / stateTotal * 10000;
  num2 = num2.toFixed(1);

  $('#casesAdj').empty().append(commafy(num));
  $('#deathsAdj').empty().append(num2);

  var myFunction = function(chosenID) {
    document.querySelectorAll('.caseKey, .covidNum, .unassigned').forEach(el => el.classList.remove('active'));
    document.getElementById(chosenID).classList.add('active');
    document.querySelectorAll(`.${chosenID}`).forEach(el => el.classList.add('active'));

    colorMap(chosenID);
  };

  var colorMap = function(chosenColor) {
    for (let i = 0; i < counties.length; i++) {
      counties[i].style.fill = "#e2e2e2";

      for (let h = 0; h < buckets[chosenColor].length; h++) {
        let bucketArray = buckets[chosenColor];
        let colorArray = colors[chosenColor];
        if ( counties[i].numbers[chosenColor] >= bucketArray[h]  ) {
           counties[i].style.fill = colorArray[h];
        }
      };
    };
  };



  document.querySelectorAll(".radioButton1").forEach(el => el.addEventListener('click', () => myFunction(el.value)) );


   myFunction('cases');

} else {}





// HOT SPOTS MAP

if($('#countyHotSpots').length >0 ){

  $('#date').empty().text(dateNew);

var hotSpots = window.case_dataHotSpots;

var countyMapGraphic = document.getElementById("HotSpotsMap");

var svgCounty = d3.select("#svg3071"),
      gCounty = svgCounty.append("g");


var unnCases = 0;
var total_state = 0;
var total_rate_state = 0;
hotSpots.forEach(function (arrayItem) {
  unnCases = (arrayItem.County === "Unassigned") ? arrayItem.total_count : unnCases;
  total_state = (arrayItem.County === "Statewide") ? arrayItem.total_count : total_state;
  total_rate_state = (arrayItem.County === "Statewide") ? arrayItem.seven_day_rate : total_rate_state;
});


$('.unassigned.cases.casesPop span').empty().append(commaFormat(unnCases));

var countyMap = document.getElementById("svg3071");
var counties = countyMap.getElementsByClassName("county");
let caseTotals = 0;

for (let i = 0; i < counties.length; i++) {
    var countyName = counties[i].id;
    var match_name = countyName.split('_').join(' ');
    match_name = match_name + " County";

    var case_value = 0;
    var popAdjCase = 0;

    hotSpots.forEach(function (arrayItem) {
      popAdjCase = (arrayItem.County === match_name) ? arrayItem.seven_day_rate : popAdjCase;
    });

    var countyObj = county_pops[i];
    var countyPop = countyObj["pop_2020"];
    case_value = Math.round((countyPop / 100000) * popAdjCase);

    var bbox = d3.select("#" + countyName).node().getBBox();

    let dataset = {
      cases: case_value,
      casesPop: popAdjCase,
    };

    counties[i].numbers = dataset;
         var centroid = [
             bbox.x + bbox.width/2,
             bbox.y + bbox.height/2
         ];

         var pushVar = 0;

         if (countyName === "Walla_Walla") { pushVar =  40; };
         if (countyName === "Garfield") { pushVar =  -20; };
         if (countyName === "Columbia") { pushVar =  10; };

         countyName = countyName.replace(/_/g, ' ');

         var circle = svgCounty.selectAll('g').append('text')
          .attr("class", "covidNum alwaysActive")
          .attr("font-weight","bold")
          .attr("text-anchor", "middle")
          .html(function () {
            let white_text =  parseFloat(popAdjCase) > buckets.casesPop_2Wks[3] ? "black" : "black";
           return (`<tspan class='headerC ${ white_text }' x='` + centroid[0] + "' y='" + (centroid[1] + pushVar) + "'>" + countyName + "</tspan>");
          });

        var circleCases = svgCounty.selectAll('g').append('text')
         .attr("class", "covidNum cases")
         .attr("font-weight","bold")
         .attr("text-anchor", "middle")
         .html(function () {
          return ("<tspan class='valueC' x='" + centroid[0] + "' y='" + (centroid[1] + pushVar + 20) + "'>" + commaFormat(case_value) + "</tspan>");
         });

        var circleAdjCases = svgCounty.selectAll('g').append('text')
         .attr("class", "covidNum casesPop")
         .attr("font-weight","bold")
         .attr("text-anchor", "middle")
         .html(function () {
           let white_text =  parseFloat(popAdjCase) > buckets.casesPop_2Wks[3] ? "black" : "black";
          return ( case_value > 0 ? `<tspan class='valueC ${ white_text }' x='` + centroid[0] + "' y='" + (centroid[1] + pushVar + 20) + "'>" + commaFormat(popAdjCase) + "</tspan>" : "<tspan class='valueC' x='" + centroid[0] + "' y='" + (centroid[1] + pushVar + 20) + "'>0</tspan>" );
         });
} // for loop end


$('#casesTotal').empty().append(commaFormat(total_state));
$('#casesAdj').empty().append(total_rate_state);

var myFunction = function(chosenID) {
  document.querySelectorAll('.caseKey, .covidNum').forEach(el => el.classList.remove('active'));
  document.getElementById(chosenID).classList.add('active');
  document.querySelectorAll(`.${chosenID}`).forEach(el => el.classList.add('active'));

  colorMap(chosenID);
};

var colorMap = function(chosenColor) {
  var chosenColor_2Wks = chosenColor + "_2Wks";
  for (let i = 0; i < counties.length; i++) {
    counties[i].style.fill = "#e2e2e2";


    for (let h = 0; h < buckets[chosenColor_2Wks].length; h++) {
      let bucketArray = buckets[chosenColor_2Wks];
      let colorArray = colors[chosenColor_2Wks];

      if ( counties[i].numbers[chosenColor] >= bucketArray[h]  ) {
         counties[i].style.fill = colorArray[h];
      }
    };
  };
};

document.querySelectorAll(".radioButton1").forEach(el => el.addEventListener('click', () => myFunction(el.value)) );
 myFunction('casesPop');

} else {}
